export const ANCHOR_LINK_TEST_ID = 'common_anchor-link';
export const BUTTON_LINK_TEST_ID = 'common_button-link';
